// @flow

import React, { PureComponent } from 'react'
import styles from './index.css'
import type { Kort } from '../domain/index'
import { bem } from '../bem'

type CardsProps = {
  kort: Array<Kort>
}

export class Cards extends PureComponent<CardsProps> {
  render () {
    const {kort} = this.props
    return (
      <div className={styles.cards}>
        {
          kort.map(({value}, idx) => (
            <div className={styles.card} key={idx}>
              <div className={styles.card__info}>
                <div className={styles.card__number}>{value.antall}</div>
                <div className={styles.card__text}>
                  <div style={{display: 'inline-block'}} dangerouslySetInnerHTML={{__html: value.tekst}} />
                </div>
              </div>
              <div className={styles.card__icons}>
                {
                  [...new Array(53)].map((icon, idx) => (
                    <div className={styles.card__person} key={idx}>
                      <div className={bem(styles.card__icon, idx < parseInt(value.antall) ? 'active' : '')} />
                    </div>
                  ))
                }
              </div>
            </div>
          ))
        }

        <div className={styles.spacer} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/cards/index.js